import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useRef } from 'react';
import {
  FormGroup, FormControlLabel, RadioGroup, Radio, FormLabel,
  Checkbox, Typography, FormControl, MenuItem, InputLabel, Select,
} from "@mui/material";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import checkAndLock from '../../../GlobalFunction/checkAndLock';
import UnLock from '../../../GlobalFunction/UnLock';
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import axiosInstance from '../../../lib/axios';
import { useReactToPrint } from 'react-to-print';
import ReportTable from "../../../atoms/ReportFolder/ReportTable"; // Assuming this is the correct import path

// Define columns for the print table
const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 5 },
  { id: "ItmCatName", label: "Category Name", minWidth: 100 },
  { id: "ItmCatAbrv", label: "Abbreviation", minWidth: 50 },
  { id: "ItmType", label: "Item Type", minWidth: 50 },
  { id: "Status", label: "Status", minWidth: 50 },
  { id: "Remark", label: "Remark", minWidth: 100 },
];

const CategoryMaster = () => {
  const { register, setValue, reset, watch } = useForm();
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [ItmCatId, setItmCatId] = useState(-1);
  const [Mode, setMode] = useState("add");
  const [TransactionData, setTransactionData] = useState([]);
  const [OpenDForDelete, setOpenDForDelete] = useState(false);
  const [AllDisUnable, setAllDisUnable] = useState(true);
  const [ItmType, setItmType] = useState("A");
  const location = useLocation();
  const navigate = useNavigate();

  const contentRef = useRef(null); // Ref for printing
  const [DataForPrint, setDataForPrint] = useState({}); // State for print data
  const [rows, setRows] = useState([]); // State for table rows
  const handlePrint = useReactToPrint({ contentRef }); // Hook for printing

  useEffect(() => {
    const fetchData = async () => {
      await fetchDashboardData(); // Fetch data for print table

      if (location.state) {
        setAllDisUnable(false);
        let ItmCatId = location.state.ItmCatId;
        setItmCatId(location.state.ItmCatId);
        await fetchTransactionData(ItmCatId, "R");
      } else {
        setMode("add");
        setAllDisUnable(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (TransactionData.length > 0 && Mode !== "add") {
      const obj = watch();
      for (let key in obj) {
        if (TransactionData[0].hasOwnProperty(key)) {
          setValue(key, TransactionData[0][key]);
        } else {
          setValue(key, "");
        }
      }
      setItmType(TransactionData[0].ItmType);
      setAllDisUnable(false);
    } else if (Mode === "add") {
      handleAddClick();
    }
  }, [TransactionData, Mode]);

  // Fetch Dashboard Data for Print Table
  const fetchDashboardData = async () => {
    try {
      const res = await axiosInstance.post("MstItmCat/GetMstItmCatDashBoard", {
        SearchText: "",
      });
      if (res.data && res.data.Data) {
        setRows(res.data.Data);
        setDataForPrint(res.data.Data);
      } else {
        setRows([]);
        setDataForPrint({});
      }
    } catch (err) {
      toast.error("Error fetching dashboard data");
    }
  };

  const fetchTransactionData = async (ItmCatId, Flag) => {
    try {
      const response = await axiosInstance.post(`MstItmCat/RetriveMstItmCat`, {
        ItmCatId,
        Flag
      });

      if (response.data.Status === 0) {
        if (Flag === "D") {
          toast.success(response.data.Message, { autoClose: 1000 });
          fetchTransactionData(ItmCatId, "L");
          return;
        }
        let Data = response.data.Data != null ? response.data.Data : [];
        setTransactionData(Data);
        setItmCatId(response.data.Data[0].ItmCatId);
        setMode("view");
      } else {
        if (Flag !== "D") {
          setItmCatId(-1);
          Mode === "view" ? setMode("add") : handleAddClick();
        }
        toast.info(response.data.Message);
      }
    } catch (error) {
      console.error('Error fetching Transaction data:', error);
    }
  };

  const handleAddClick = () => {
    setMode("add");
    setAllDisUnable(true);
    resetFunc();
  };

  const handleEditClick = async () => {
    let Flag = await checkAndLock(ItmCatId, "MstItmCat", "ItmCatId");
    switch (Flag) {
      case 0:
        setMode("view");
        setAllDisUnable(true);
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleCancelDButton = () => {
    setOpenDForDelete(false);
  };

  const handleSubmitClick = async () => {
    const Obj = watch();

    if (!Obj.ItmCatName || !Obj.ItmCatAbrv) {
      toast.error("Please fill out all the required fields.", { autoClose: 2000 });
      return;
    }

    let Payload = {
      "ItmCatName": watch("ItmCatName"),
      "ItmCatAbrv": watch("ItmCatAbrv"),
      "Remark": watch("Remark"),
      "Status": watch("Status"),
      "ItmType": ItmType,
      CreatedBy: parseInt(UserId)
    };

    if (Mode === "add") {
      try {
        const response = await axiosInstance.post(`MstItmCat/InsertMstItmCat`,
          Payload,
        );

        if (response.data.Status === 0) {
          toast.success(response.data.Message, { autoClose: 1000 });
          fetchTransactionData(1, "L");
          setMode("view");
          setAllDisUnable(false);
        } else {
          toast.info(response.data.Message);
        }
      } catch (error) {
        console.error('Error inserting data:', error);
      }
    } else {
      Payload = { ...Payload, ItmCatId, UpdatedBy: parseInt(UserId) };
      delete Payload.CreatedBy;

      try {
        const response = await axiosInstance.post(`MstItmCat/UpdateMstItmCat`,
          Payload,
        );

        if (response.data.Status === 0) {
          toast.success(response.data.Message, { autoClose: 1000 });
          await UnLock(ItmCatId, "MstItmCat", "ItmCatId");
          fetchTransactionData(ItmCatId, "R");
          setAllDisUnable(false);
        } else {
          toast.info(response.data.Message);
        }
      } catch (error) {
        console.error('Error updating data:', error);
      }
    }
  };

  const handleCancelClick = async () => {
    if (ItmCatId === -1 && Mode === "add") {
      await fetchTransactionData(1, "L");
    } else {
      await UnLock(ItmCatId, "MstItmCat", "ItmCatId");
      await fetchTransactionData(ItmCatId, "R");
    }
  };

  const handleDeleteClick = () => {
    setOpenDForDelete(true);
  };

  const handleClickBackToTable = () => {
    navigate('/categorytable');
  };

  const handleCatChange = (e) => {
    setValue("ItmType", e.target.value);
    setItmType(e.target.value);
  };

  const handleConfirmDDelete = () => {
    fetchTransactionData(ItmCatId, "D");
    setOpenDForDelete(false);
  };

  const handleNextClick = () => {
    fetchTransactionData(ItmCatId, "N");
  };

  const handlePrevClick = () => {
    fetchTransactionData(ItmCatId, "P");
  };

  const resetFunc = () => {
    reset({
      "ItmCatName": "",
      "ItmCatAbrv": "",
      "Remark": "",
      "ItmType": "A",
      "Status": "1",
    });
  };

  const handleCheckBoxChange = (e) => {
    setValue("Status", watch("Status") === "1" ? "0" : "1");
  };

  return (
    <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
      <Dialog
        open={OpenDForDelete}
        onClose={handleCancelDButton}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Do You Want To Delete The Unit ?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCancelDButton}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer />
      <Grid container spacing={2} className='form_grid'>
        <Grid item xs={12} className='form_title'
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: '20px',
            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
          }}
        >
          <Grid
            sx={{
              display: 'flex',
              justifyContent: { xs: 'center', sm: 'flex-start' },
              marginBottom: { xs: '10px', sm: 0 }
            }}
          >
            <Button
              variant="contained"
              size="small"
              className='three-d-button-previous'
              sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
              onClick={handlePrevClick}
              disabled={AllDisUnable}
            >
              <KeyboardArrowLeftIcon />
            </Button>

            <Button
              variant="contained"
              size="small"
              className='three-d-button-next'
              sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
              onClick={handleNextClick}
              disabled={AllDisUnable}
            >
              <NavigateNextIcon />
            </Button>
          </Grid>

          <Typography
            variant="h5"
            sx={{
              margin: 'Auto',
              textAlign: { xs: 'center', sm: 'center' },
              fontSize: { xs: '24px', sm: '18px', md: '24px' }
            }}
          >
            Category Master
          </Typography>

          <Grid sx={{ display: "flex", justifyContent: "end" }}>
            <CrudButtons
              moduleName="Category Master"
              mode={Mode}
              onAdd={handleAddClick}
              onEdit={handleEditClick}
              onView={handlePrint}
              onDelete={handleDeleteClick}
              onExit={handleClickBackToTable}
              readOnlyMode={!AllDisUnable}
              onPrevious={handlePrevClick}
              onNext={handleNextClick}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} md={10} className='form_field' sx={{ marginX: "auto" }}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={5}>
              <TextField
                id="ItmCatName"
                name="ItmCatName"
                label={
                  <span>
                    Category Name <span style={{ color: 'red' }}>*</span>
                  </span>
                }
                value={watch('ItmCatName') || ''}
                {...register("ItmCatName")}
                variant="filled"
                fullWidth
                className="custom-textfield"
                disabled={!AllDisUnable}
              />
            </Grid>

            <Grid item xs={12} md={5}>
              <TextField
                id="ItmCatAbrv"
                name="ItmCatAbrv"
                label={<span>Abbreviation <span style={{ color: 'red' }}>*</span></span>}
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={watch('ItmCatAbrv') || ''}
                {...register("ItmCatAbrv")}
                disabled={!AllDisUnable}
              />
            </Grid>

            <Grid item xs={12} md={5}>
              <TextField
                id="Remark"
                name="Remark"
                label="Remark"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={watch('Remark') || ''}
                {...register("Remark")}
                disabled={!AllDisUnable}
              />
            </Grid>

            <Grid item xs={12} md={5}>
              <Grid container alignItems="center" spacing={1} sx={{ paddingLeft: '9px' }}>
                <Grid item>
                  <FormLabel component="legend" sx={{ fontWeight: 'bold' }}>Item Type</FormLabel>
                </Grid>

                <Grid item>
                  <FormControl component="fieldset">
                    <RadioGroup name='ItmType' row value={ItmType}
                      {...register('ItmType')}
                      onChange={handleCatChange}
                    >
                      <FormControlLabel
                        value="A"
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                        label="Asset"
                        className="custom-textfield"
                      />
                      <FormControlLabel
                        value="C"
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                        label="Consumable"
                        className="custom-textfield"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={2}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={!AllDisUnable}
                      name="Status"
                      checked={watch("Status") === "1"}
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Status"
                />
              </FormGroup>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} className="form_button">
          <Button
            variant="contained"
            sx={{
              mr: 1,
              background: 'linear-gradient(290deg, #d4d4d4, #ffffff)',
            }}
            onClick={handleSubmitClick}
            disabled={!AllDisUnable}
          >
            Submit
          </Button>
          <Button
            variant="contained"
            sx={{
              mr: 1,
              background: 'linear-gradient(290deg, #a7c5e9, #ffffff)',
            }}
            onClick={handleCancelClick}
            disabled={!AllDisUnable}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>

      {/* Hidden Print Section */}
      <div style={{ display: "none" }}>
        {Object.keys(DataForPrint).length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows}
            title="Category Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: "#f5f5f5" }}
          />
        )}
      </div>
    </Box>
  );
};

export default CategoryMaster;